<template>
  <base-material-card
    color="primary"
    icon="mdi-chart-line"
    inline
    class="px-5 py-4"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        COGE
      </div>
    </template>
    <v-form class="pt-5">
      <v-row
        align="center"
        no-gutters
        class="ml-4"
      >
        <v-col cols=12>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Codigos MCPSE"
          >
            <v-textarea
              :error-messages="errors"
              autofocus
              clearable
              clear-icon="mdi-close-circle"
              label="Códigos MCPSE"
              placeholder="Insira os códigos MCPSE, um código por linha, seguindo o formato: TUC.A1.A2.A3.A4.A5.A6"
              rows="5"
              no-resize
              v-model="codigos"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  export default {
    name: 'BasicInfoConsultar',

    data () {
      return {
        codigos: "",
      }
    },

    methods: {
      exportData() {
        return {
          codigos: this.codigos
        }
      }
    }
  }
</script>